import { create } from 'zustand';
import { RedirectURI } from '../types/ApplicationType';

interface ApplicationStore {
    createMode: boolean;
    setCreateMode: (obj: boolean) => void;

    name: string;
    setName: (obj: string) => void;

    description: string;
    setDescription: (obj: string) => void;

    website: string;
    setWebsite: (obj: string) => void;

    redirectUri: RedirectURI[];
    setRedirectUri: (obj: RedirectURI[]) => void;

    selectedOptions: string[];
    setSelectedOptions: (obj: string[]) => void;

    resetStore: () => void;
}

const useApplicationStore = create<ApplicationStore>((set) => ({
    createMode: true,
    setCreateMode: (obj) => set({ createMode: obj }),

    name: '',
    setName: (obj) => set({ name: obj }),

    description: '',
    setDescription: (obj) => set({ description: obj }),

    website: '',
    setWebsite: (obj) => set({ website: obj }),

    redirectUri: [{ id: 'xxx', redirectURI: '' }],
    setRedirectUri: (obj) => set({ redirectUri: obj }),

    selectedOptions: [],
    setSelectedOptions: (obj) => set({ selectedOptions: obj }),

    resetStore: () => set({
        name: '',
        description: '',
        website: '',
        redirectUri: [{ id: 'xxx', redirectURI: '' }],
        selectedOptions: [],
    })
}));

export default useApplicationStore;
